import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import "./assets/fonts/FivoSans-Regular.otf";

const root = ReactDOM.createRoot(document.getElementById("root"));

// i am using error boundary in main layout file
root.render(<App />);

reportWebVitals();
